<template>
    <div>
        <h1>
        Users
        <md-button @click="bulkAddUsers" class="md-fab md-mini md-accent">
            <md-icon>post_add</md-icon>
            <md-tooltip md-direction="top">Add from spreadsheet</md-tooltip>
        </md-button>
        <md-button @click="addUser" class="md-fab md-mini md-accent">
            <md-icon>add</md-icon>
            <md-tooltip md-direction="top">Add a user</md-tooltip>
        </md-button>     
        </h1>

        <div v-if="!users">Loading...</div>

        <md-list class="md-double-line">
        <md-list-item v-for="user in users" :key="user.uid">
            <md-icon class="md-primary">person</md-icon>

            <div class="md-list-item-text">
            <span>{{ user.displayName }} {{ user.email }}</span>
            <span v-if="isSuperAdmin">{{ user.uid }}</span>
            <span v-if="isSuperAdmin">{{ user.orgId }}</span>
            </div>
            <md-chip v-for="role in user.roles" :key="role">{{ role }}</md-chip>

            <md-button class="md-icon-button md-list-action" @click="editUser(user)" >
            <md-icon>edit</md-icon>
            </md-button>
        </md-list-item>
        </md-list>

        <UserListAddEditUser ref="addUserDialog" @user-save="onUserAdd" :isEdit="false"/>
        <UserListAddEditUser ref="editUserDialog" @user-save="onUserEdit" @user-delete="onUserDelete" :isEdit="true"/>
        <UserListBulkAddUsers ref="bulkAddUsersDialog" @dialog-closed="onBulkDialogClosed" />

        <md-snackbar
        :md-position="'center'"
        :md-duration="10000"
        :md-active.sync="showSnackbar"
        md-persistent
        >
        <span>{{ message }}</span>
        </md-snackbar>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { functions } from "../firebaseFunctions.js";
import { AuthService } from "../services/auth.service";
import UserListAddEditUser from "@/components/UserListAddEditUser.vue";
import UserListBulkAddUsers from "@/components/UserListBulkAddUsers.vue";

export default {
    name: "UserList",
    components: {
        UserListAddEditUser,
        UserListBulkAddUsers
    },
    data: () => ({
        users: null,
        showSnackbar: false,
        message: ""
    }),
    methods: {
        getUsers() {
        functions
            .getAllUsers()
            .then(result => {
            this.users = result.data;
            })
            .catch(error => {
            console.log(error);
            });
        },
        addUser() {
            this.$refs.addUserDialog.showDialog();
        },
        editUser(user) {
            this.$refs.editUserDialog.showDialog(user);
        },
        bulkAddUsers() {
            this.$refs.bulkAddUsersDialog.showDialog();
        },
        onUserAdd(user) {
            user.sendEmail = true;
            functions
                .addUser(user)
                .then(() => {
                    this.getUsers();
                    this.message = `User '${user.email}' successfully added`;
                    this.showSnackbar = true;
                }, (error) => {
                    console.error(error);
                    this.message = `Could not add the user. Error occured: '${error}'`;
                    this.showSnackbar = true;
                });
        },
        onUserEdit(user) {
            functions
                .updateUser(user)
                .then(() => {
                    this.getUsers();
                    this.message = `User '${user.email}' successfully updated`;
                    this.showSnackbar = true;
                }, (error) => {
                    console.error(error);
                    this.message = `Could not update the user. Error occured: '${error}'`;
                    this.showSnackbar = true;
                });
        },
        onUserDelete(user) {
            functions
                .deleteUser(user)
                .then(() => {
                    this.getUsers();
                    this.message = `User '${user.email}' successfully deleted`;
                    this.showSnackbar = true;
                }, (error) => {
                    console.error(error);
                    this.message = `Could not update the user. Error occured: '${error}'`;
                    this.showSnackbar = true;
                })
        },
        onBulkDialogClosed() {
            this.getUsers();
        }
    },
    computed: {    
        isSuperAdmin() {
        return this.authenticatedUser.roles && this.authenticatedUser.roles.includes("superadmin");
        }
    },
    created: function() {
        this.subscription = AuthService.loggedUser$.subscribe(user => {
        this.authenticatedUser = user;
        });

        this.getUsers();
    },
    beforeDestroy() {
        this.subscription.unsubscribe();
    }
};
</script>

<style scoped lang="scss">
    .md-fab {
        float: right;
        margin-top: -9px;
    }
</style>
